import React, { useState, useEffect } from 'react';
import axios from "axios";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Grid,
  Typography,
  Box,
  Tooltip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';
import EditIcon from '@mui/icons-material/Edit';
import useUserId from "hooks/useUserId";

const EmailPopup = ({
  open,
  onClose,
  receiverEmail,
  postTitle,
  onSendEmail,
}) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const userId = useUserId();

  const [senderEmail, setSenderEmail] = useState('');
  const [receiverEmailEditable, setReceiverEmailEditable] = useState(receiverEmail || '');
  const [emailBody, setEmailBody] = useState('');
  const [emailSubject, setEmailSubject] = useState('');
  const [DataAdmin, setDataAdmin] = useState('');
  const [error, setError] = useState({
    receiverEmail: false,
    emailBody: false,
    emailSubject: false,
  });
  const [isEditingReceiver, setIsEditingReceiver] = useState(false);

  useEffect(() => {
    fetchRecruiterData();
  }, [postTitle]);

  const fetchRecruiterData = async () => {
    try {
      const response = await axios.get(`${apiUrl}recruiters/${userId.userId}/find/`);

      const adminData = response.data; // Assuming this is the single object
      const filteredData = {
        first_name: adminData.first_name,
        last_name: adminData.last_name,
        company_logo: adminData.created_by?.company_logo || null,
        company: adminData.company,
        address: adminData.created_by?.address || null,
        email: adminData.email,
      };

      setDataAdmin(filteredData);

      console.log('Here is my data!', filteredData);

      // Construct the email subject and body
      const defaultSubject = `New Updates about your Application for: ${postTitle} offer`;
      const defaultBody = `Dear Candidate,
      I hope this message finds you well! I am reaching out regarding an exciting opportunity for your Application for: ${postTitle} offer".

      Based on your background and skills, we believe you could be a great fit for this role. If you are interested, please let us know a convenient time to discuss further or feel free to share any questions you may have about the position.

      Looking forward to hearing from you soon!

      Best regards,  
      ${filteredData.first_name} ${filteredData.last_name}  
      Recruiter at ${filteredData.company}
      Address: ${filteredData.address || "Not provided"}  
      Email: ${filteredData.email}`;


      setEmailSubject(defaultSubject);
      setEmailBody(defaultBody);
    } catch (err) {
      console.error("Error fetching admin data:", err);
      setEmailSubject("");
      setEmailBody("");
    }
  };


  const validateEmail = (email) => {
    if (!email) return false; // Ensure email is not null or empty
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.toLowerCase());
  };


  const handleSendEmail = () => {


    const isReceiverEmailValid = validateEmail(receiverEmailEditable);
    const isEmailBodyValid = emailBody.trim().length > 0;
    const isEmailSubjectValid = emailSubject.trim().length > 0;

    setError({
      receiverEmail: !isReceiverEmailValid,
      emailBody: !isEmailBodyValid,
      emailSubject: !isEmailSubjectValid,
    });

    if (isReceiverEmailValid && isEmailBodyValid && isEmailSubjectValid) {
      const emailData = {
        userId: userId.userId,
        to: receiverEmailEditable,
        subject: emailSubject,
        body: emailBody,
      };
      console.log('before sending: ', emailData);
      onSendEmail(emailData);

      setReceiverEmailEditable(receiverEmail);
      setEmailBody('');
      setEmailSubject('');
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" flexDirection="column" gap={2}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" fontWeight="bold">
              Send Email
            </Typography>
            <Tooltip title="Close">
              <IconButton aria-label="close" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Box>
          <TextField
            label="Email Subject"
            type="text"
            fullWidth
            variant="outlined"
            value={emailSubject}
            onChange={(e) => setEmailSubject(e.target.value)}
            error={error.emailSubject}
            helperText={error.emailSubject ? 'Subject cannot be empty' : ''}
            required
          />

        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12} display="flex" gap={2}>

            <TextField
              label="Recipient Email"
              type="email"
              fullWidth
              variant="outlined"
              value={receiverEmailEditable}
              onChange={(e) => setReceiverEmailEditable(e.target.value)}
              error={error.receiverEmail}
              helperText={error.receiverEmail ? 'Please enter a valid email' : ''}
              disabled={!isEditingReceiver}
              required
            />
            <Tooltip title="Edit Recipient Email">
              <IconButton
                color={isEditingReceiver ? 'primary' : 'default'}
                onClick={() => setIsEditingReceiver((prev) => !prev)}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Email Body"
              type="text"
              fullWidth
              multiline
              rows={10} // Increased rows for more space
              variant="outlined"
              value={emailBody}
              onChange={(e) => setEmailBody(e.target.value)}
              error={error.emailBody}
              helperText={error.emailBody ? 'Email body cannot be empty' : ''}
              required
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleSendEmail}
          color="primary"
          variant="contained"
          startIcon={<SendIcon />}
          disabled={!validateEmail(receiverEmailEditable)}
        >
          Send Email
        </Button>

      </DialogActions>

    </Dialog>
  );
};

export default EmailPopup;
